import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

class Privacy extends Component {
    render() {
        return (
            <div className="ckp-info-page">
                <section className="ckp-info-page-section">
                    <h1 className="ckp-info-page-title u-text-center u-bold">
                        Privacy Policy - Clear’em BV - 1 January 2020
                    </h1>
                    <p className="ckp-info-page-paragraph u-italic">
                        We recommend that you read this Privacy Policy carefully before using CLEAR’EM’s websites,
                        products and services. Your personal data is important to us. That is why we want to protect it
                        at all costs. When using your personal data, we always respect the rights granted to you by law.
                    </p>
                </section>
                <section className="ckp-info-page-section">
                    <h2 className="ckp-info-page-subtitle">A. Scope and purpose of this Privacy Policy</h2>
                    <h3 className="ckp-info-page-subsubtitle">1. General Data Protection Policy</h3>
                    <p className="ckp-info-page-paragraph">
                        CLEAR’EM is committed to protecting the privacy and personal data of its customers and of those
                        who use its services. We comply with all requirements as defined by applicable data protection
                        regulations. Our Data Protection Policy is designed to provide transparency with respect to our
                        practices and principles in this area.
                    </p>
                    <h3 className="ckp-info-page-subsubtitle">2. Scope of our Privacy Policy</h3>
                    <p className="ckp-info-page-paragraph">
                        This Privacy Policy on the Protection of Personal Data (“Data Protection Policy”) describes the
                        personal information we collect and use, the purposes for which it is collected, where it is
                        stored and how long it is retained.
                    </p>
                    <h3 className="ckp-info-page-subsubtitle">3. Data controller</h3>
                    <p className="ckp-info-page-paragraph">
                        CLEAR’EM is a private limited liability company registered in Belgium under company number
                        735.786.174 and has its registered office at Gabriëllelei 1, 2930 Brasschaat (“CLEAR’EM” or
                        “We”). CLEAR’EM is the data controller with respect to the CLEAR’EM websites and applications.
                        In addition, CLEAR’EM may rely on carefully selected data processors for this purpose. These are
                        natural or legal persons who process personal data on behalf of CLEAR’EM.
                    </p>
                    <h3 className="ckp-info-page-subsubtitle">4. Amendments</h3>
                    <p className="ckp-info-page-paragraph">
                        We have the right to change this Data Protection Policy at any time. Whenever CLEAR’EM makes
                        changes to this Data Protection Policy, the date at the top of this document will be updated in
                        the latest version.
                    </p>
                </section>
                <section className="ckp-info-page-section">
                    <h2 className="ckp-info-page-subtitle">B. Processing of personal data by CLEAR’EM</h2>
                    <h3 className="ckp-info-page-subsubtitle">1. Data subjects</h3>
                    <p className="ckp-info-page-paragraph">We collect and process personal data of</p>
                    <ul>
                        <li>
                            users who visit CLEAR’EM websites, whether for information purposes only or for the purpose
                            of using our services (the “Users”), and 
                        </li>
                        <li>
                            of customers of the CLEAR’EM service tools, applications and licensees of CLEAR’EM’s
                            services or of the individual tools.
                        </li>
                    </ul>
                    <h3 className="ckp-info-page-subsubtitle">2. Which personal information do we collect?</h3>
                    <p className="ckp-info-page-paragraph">
                        We collect information that you provide to us, information about your visits to our website,
                        your contact details and any other information you may provide.
                    </p>
                    <ul>
                        <li>Information you provide yourself</li>
                    </ul>
                    <p className="ckp-info-page-paragraph">
                        Sometimes you voluntarily provide personal data directly to us, e.g. for the use of the CLEAR’EM
                        tools. This includes information such as your name, address, email, date of birth, billing
                        information and offline and online user identification data, including data from your social
                        media accounts.
                    </p>
                    <ul>
                        <li>Information we collect through our website</li>
                    </ul>
                    <p className="ckp-info-page-paragraph">
                        We collect technical information about each visitor to our website(s). Examples include your IP
                        address, browser, device information, etc. In addition, we track how each visitor uses the
                        website. For example, we know exactly when people visit our website, how a web page is viewed,
                        where they click, when they leave the website again, etc. This information allows us to improve
                        the user-friendliness of our website. We use cookies to build this knowledge across different
                        visits to our website. A cookie is a piece of information that your browser stores for us and
                        returns to us at a later time, for example when you visit our website again.{' '}
                    </p>
                    <h3 className="ckp-info-page-subsubtitle">3. Why do we collect your personal information?</h3>
                    <p className="ckp-info-page-paragraph">
                        We need your information to provide you with our services. In the first place, we need your data
                        to allow you to use the CLEAR’EM tool and services, but also for communication, customer and
                        billing purposes. We apply strict internal communication rules and use your data to continuously
                        improve our services.
                    </p>
                    <ul>
                        <li>Processing for the purpose of providing services</li>
                    </ul>
                    <p className="ckp-info-page-paragraph">
                        The information we ask you to provide when you create a profile or account is necessary for us
                        to comply with our agreements with you. For example, we can offer you a discount or a promotion,
                        help you with your events and clear rights for you.
                    </p>
                    <ul>
                        <li>Processing for communication purposes</li>
                    </ul>
                    <p className="ckp-info-page-paragraph">
                        Your information can also be used to send you marketing emails. These emails may include
                        updates, events, news or new services and products on which we would like to inform you.
                    </p>
                    <h3 className="ckp-info-page-subsubtitle">4. Who has access to your data?</h3>
                    <p className="ckp-info-page-paragraph">
                        CLEAR’EM BV manages your data and will never sell it. We may, however, use the services of other
                        parties to provide our services. Such parties will always respect the terms of this Data
                        Protection Policy.
                    </p>
                    <p className="ckp-info-page-paragraph">
                        Law firms, collection agencies, bailiffs, insurance companies or banks may also receive access
                        to part of your personal information if they need it to assist us in handling a case, making
                        payments, etc. In some cases, certain (public) authorities will have the right to view or
                        request part of your personal information. In such situations we will, of course, offer our
                        cooperation.
                    </p>

                    <h3 className="ckp-info-page-subsubtitle">5. Where is your personal information stored?</h3>
                    <p className="ckp-info-page-paragraph">
                        Your personal information will be stored in Belgium. It will not be exchanged outside the
                        European Union.
                    </p>
                    <h3 className="ckp-info-page-subsubtitle">6. How long do we keep your personal information?</h3>
                    <p className="ckp-info-page-paragraph">
                        We only retain personal information for as long as reasonably necessary in the context of our
                        relationship with users/visitors. For your profile information, we apply the basic rule that we
                        remove it if you have not used your profile for 5 years. We store your emails with questions for
                        as long as necessary for answering and handling them. Sometimes we are required by law to retain
                        data for a longer period of time, for example in the case of invoices or data that can be used
                        in the event of a dispute. In such cases, we will comply with the longer retention period.
                    </p>

                    <h3 className="ckp-info-page-subsubtitle">7. How do we protect your personal information?</h3>
                    <p className="ckp-info-page-paragraph">
                        The security, integrity and confidentiality of personal information are extremely important to
                        us. We use state-of-the-art security measures designed to protect your information from
                        unauthorized access, disclosure, use and alteration, to the best of our ability. We use secure
                        connections when you and/or other users provide payment information via the CLEAR’EM websites.
                        When we work with other parties, we required the same level of security from them. However,
                        despite all our efforts in this area, we can never fully guarantee the security and protection
                        of your personal information.
                    </p>
                </section>
                <section className="ckp-info-page-section">
                    <h2 className="ckp-info-page-subtitle">C. Exercising your data protection rights</h2>
                    <p className="ckp-info-page-paragraph">
                        We always respect the rights you granted to you by data protection regulations. For example, you
                        can have any incorrect or incomplete data rectified, or you can ask us not to use your data for
                        direct marketing, etc.
                    </p>
                    <br />
                    <p className="ckp-info-page-paragraph">
                        If you want to exercise your rights under this policy, please contact us using the contact
                        details at the bottom of this Data Protection Policy. In these cases, we are obliged to verify
                        your identity. We can do this online by checking your login details. If you contact us in any
                        other way, we will ask you to send us a copy of the front of your identity card.
                    </p>
                    <br />
                    <p className="ckp-info-page-paragraph">What are your rights?</p>
                    <ul>
                        <li>You may request us to send you an overview of any personal data we store about you.</li>
                        <li>You may request us to rectify any incorrect personal information.</li>
                        <li>You may request us to erase personal data that is no longer relevant.</li>
                        <li>You may request us to transfer personal data to another party.</li>
                        <li>
                            You may request us not to use your personal data for direct marketing purposes. Use the
                            unsubscribe option in the marketing email to do this.
                        </li>
                        <li>
                            You may ask us to restrict the use of your personal data or object to the use of your
                            personal data.
                        </li>
                    </ul>
                </section>
                <section className="ckp-info-page-section">
                    <h2 className="ckp-info-page-subtitle">D. Complaints on the treatment of your personal data</h2>
                    <p className="ckp-info-page-paragraph">
                        Do you have any complaints about how we handle your personal data or do you have any questions
                        about your rights? Please contact our Data Protection Officer by sending a letter to Ankerrui 9,
                        2000 Antwerp, by email at <a href="mailto:hello@clearem.tv">hello@clearem.tv</a> or call us at
                        +32 498 27 44 89. <br />
                        If our Data Protection Officer is unable to help you, you can also contact the Belgian Data
                        Protection Authority and file a complaint with them.
                    </p>
                </section>

                <section className="ckp-info-page-section">
                    <h2 className="ckp-info-page-subtitle">E. Miscellaneous</h2>
                    <ul>
                        <li>
                            Jurisdiction - This Privacy Policy is governed by and shall be construed in accordance with
                            Belgian law.
                        </li>
                        <li>
                            Severability - If any provision of this Privacy Policy is found to be unlawful, invalid or
                            unenforceable for any other reason, this provision shall be deemed severable from the rest
                            of the Data Protection Policy and shall not affect the validity and enforceability of the
                            remaining provisions.
                        </li>
                        <li>
                            Survival - The provisions of this Data Protection Policy, which will survive its termination
                            by their very nature, shall remain in effect after such termination.
                        </li>
                    </ul>
                </section>
            </div>
        );
    }
}

const mapStateToProps = state => ({});

const mapDispatchToProps = dispatch => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Privacy);



// WEBPACK FOOTER //
// ./src/containers/authentication/Privacy.js